import React, { useState, useMemo } from "react";
import { Modal, Button } from "react-bootstrap";

function ServerErrorModal({ onClose }: { onClose?: () => void }) {
  const [closed, setClosed] = useState(false);
  const show = useMemo(() => !closed, [closed]);

  const onCloseClick = () => {
    setClosed(true);
    if (onClose) onClose();
  };

  return (
    <Modal show={show} onHide={onCloseClick}>
      <Modal.Header closeButton>
        <Modal.Title>Error Inesperado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Problemas en la comunicación con el servidor, por favor contacte al
        soporte técnico.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseClick}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ServerErrorModal;
